import Firebase from 'firebase'

const firebaseApp = Firebase.initializeApp({
  apiKey: 'AIzaSyAUgyd3AU3kqvMKOb7ID2rt1m2efb-1lqw',
  authDomain: 'restargentinaonline.firebaseapp.com',
  databaseURL: 'https://restargentinaonline.firebaseio.com',
  projectId: 'restargentinaonline',
  storageBucket: 'restargentinaonline.appspot.com',
  messagingSenderId: '11618306350'
})

export const db = firebaseApp.database()



// WEBPACK FOOTER //
// ./src/firebase/index.js